module.exports = __webpack_public_path__ + "static/media/settings.18efd216.svg";